import { render, staticRenderFns } from "./InvoiceResults.vue?vue&type=template&id=4b499c50"
import script from "./InvoiceResults.vue?vue&type=script&lang=js"
export * from "./InvoiceResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports